module.exports = __webpack_public_path__ + "img/demo-pic.4398d1b6.png";